import { render } from "./NewAttachmentContextMenu.vue?vue&type=template&id=2b0cfe84"
import script from "./NewAttachmentContextMenu.vue?vue&type=script&lang=js"
export * from "./NewAttachmentContextMenu.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NewAttachmentContextMenu.vue?vue&type=style&index=0&id=2b0cfe84&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__